import React from 'react';
import { Box, Container, Typography, Button, Grid, Card, CardContent, CardActions } from '@mui/material';
import { useTheme } from '@mui/material/styles';
import DownloadIcon from '@mui/icons-material/Download';
import Certifications from '../components/sections/Certifications';
import SectionDivider from '../components/common/SectionDivider';

const CertificationsPage = () => {
  const theme = useTheme();

  const downloadPDF = (filename, displayName) => {
    const link = document.createElement('a');
    link.href = `/${filename}`;
    link.download = displayName;
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const certificateDocuments = [
    {
      title: 'ANR Capability Statement',
      description: 'Complete overview of our capabilities, certifications, and company profile.',
      filename: 'ANR Capability Statement.pdf',
      displayName: 'ANR_Capability_Statement.pdf'
    },
    {
      title: 'Professional Certifications',
      description: 'Our professional licenses, certifications, and industry credentials.',
      filename: 'SKM_C36825110521000.pdf',
      displayName: 'ANR_Professional_Certifications.pdf'
    }
  ];

  return (
    <Box component="main" sx={{ pt: 10 }}>
      <Container maxWidth="lg" sx={{ py: 2 }}>
        <Typography variant="h2" sx={{ 
          mb: 2, 
          fontWeight: 800, 
          textAlign: 'center',
          color: 'success.main'
        }}>
          Certifications & Credentials
        </Typography>
        <Typography variant="h6" sx={{ 
          mb: 3, 
          textAlign: 'center',
          color: 'text.secondary',
          maxWidth: 800,
          mx: 'auto'
        }}>
          Our professional certifications and credentials demonstrate our commitment to excellence and industry standards.
        </Typography>
      </Container>

      {/* Download Section */}
      <Container maxWidth="lg" sx={{ py: 4 }}>
        <Typography variant="h4" sx={{ 
          mb: 4, 
          fontWeight: 700, 
          textAlign: 'center',
          color: 'text.primary'
        }}>
          Download Our Certificates
        </Typography>
        
        <Grid container spacing={4} sx={{ mb: 6 }}>
          {certificateDocuments.map((doc, index) => (
            <Grid item xs={12} md={6} key={index}>
              <Card sx={{ 
                height: '100%',
                display: 'flex',
                flexDirection: 'column',
                transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                '&:hover': {
                  transform: 'translateY(-4px)',
                  boxShadow: theme.shadows[8]
                }
              }}>
                <CardContent sx={{ flexGrow: 1 }}>
                  <Typography variant="h6" sx={{ 
                    mb: 2, 
                    fontWeight: 600,
                    color: 'primary.main'
                  }}>
                    {doc.title}
                  </Typography>
                  <Typography variant="body2" sx={{ 
                    color: 'text.secondary',
                    lineHeight: 1.6
                  }}>
                    {doc.description}
                  </Typography>
                </CardContent>
                <CardActions sx={{ p: 2, pt: 0 }}>
                  <Button
                    variant="contained"
                    startIcon={<DownloadIcon />}
                    onClick={() => downloadPDF(doc.filename, doc.displayName)}
                    sx={{ 
                      width: '100%',
                      py: 1.5,
                      fontWeight: 600
                    }}
                  >
                    Download PDF
                  </Button>
                </CardActions>
              </Card>
            </Grid>
          ))}
        </Grid>
      </Container>
      
      <SectionDivider variant="wave" color="success.main" mt={1} mb={2} />
      
      <Box sx={{ background: `linear-gradient(180deg, ${theme.palette.grey[50]}, rgba(76,175,80,0.05))` }}>
        <Certifications />
      </Box>
      
      <SectionDivider variant="line" color="success.main" mt={6} mb={6} />
      
      <Container maxWidth="lg" sx={{ py: 4, textAlign: 'center' }}>
        <Button 
          variant="contained" 
          size="large"
          href="tel:(516) 414-0165"
          sx={{ 
            px: 4, 
            py: 2,
            fontSize: '1.1rem',
            fontWeight: 600
          }}
        >
          Verify Our Credentials
        </Button>
      </Container>
    </Box>
  );
};

export default CertificationsPage;
